import { useTranslation } from 'react-i18next'
import { TYPES_MENU_LIST } from '../constants/menu'

const ProductSafety = () => {
  const { t } = useTranslation()
  return (
    <div id={t(TYPES_MENU_LIST.PRODUCT_SAFETY)}>
      <h2>{t('Seguridad de los productos')}</h2>
      <p>
        {t(
          'De acuerdo a lo establecido en el Reglamento (UE) 2023/988 del Parlamento Europeo y del Consejo de 10 de mayo de 2023 relativo a la seguridad general de los productos (GPSR), se facilita la siguiente información de los productos comercializados por EDITORIAL VICENS VIVES, S.A.U.:'
        )}
      </p>
      <p>
        {t(
          '1. Los productos comercializados no tienen elementos de riesgo para la seguridad de los usuarios.'
        )}
      </p>
      <p>
        {t(
          '2. La información que se proporciona en los productos es la siguiente:'
        )}
      </p>
      <p>{`(c) ${t('EDITORIAL VICENS VIVES, S.A.U.')}`}</p>
      <p>{`${t('Dirección')}: ${t(
        'Vía Augusta, 260, Local B, 08017 - BARCELONA'
      )}`}</p>
      <p>{`${t('Teléfono')}: 932523700`}</p>
      <p>{`${t('email')}: ${t('legal@vicensvives.com')}`}</p>
      <p>
        {t(
          '3. En el caso que, en un futuro, se comercialicen productos con elementos no seguros, se facilitará toda la información necesaria a los consumidores acerca de las características, condiciones y recomendaciones de seguridad.'
        )}
      </p>
    </div>
  )
}

export default ProductSafety
